import React, { useLayoutEffect } from 'react';

import AudioOfTheDay from 'components/NewExplorePage/AudioOfTheDay';
import ExploreBy from 'components/NewExplorePage/ExploreBy';
import SearchBar from 'components/NewExplorePage/SearchBar';
import Series from 'components/NewExplorePage/Series';
import StickyBanner from 'components/NewExplorePage/StickyBanner';
import PageContainer from 'components/PageContainer';
import TrialReminder from 'components/TrialReminder';

import ShowFullCatalogButton from 'containers/Explore/ShowFullCatalogButton';

import './style.scss';

const NewExplorePage = () => {
  const stickyBannerRef = React.useRef<HTMLDivElement>(null);
  const [stickyBannerHeight, setStickyBannerHeight] = React.useState(0);

  useLayoutEffect(() => {
    setStickyBannerHeight(stickyBannerRef.current?.clientHeight || 0);
  }, []);

  return (
    <PageContainer>
      <div
        className="NewExplorePage"
        style={{ paddingTop: stickyBannerHeight }}
      >
        <StickyBanner ref={stickyBannerRef} />
        <SearchBar />
        <ExploreBy />
        <AudioOfTheDay />
        <Series />
        <ShowFullCatalogButton />
        <TrialReminder showCTA />
      </div>
    </PageContainer>
  );
};

export default NewExplorePage;
